import videojs from 'video.js';
import NotificationModal from './notification-modal';
const Plugin = videojs.getPlugin('plugin');

const DEFAULTS = {
  showTime: 5,
};

class NotificationPlugin extends Plugin {
  constructor(player, options) {
    super(player);
    this.notificationOptions = Object.assign({}, DEFAULTS, options);
  }

  notify(message) {
    if (!this.notificationModal || this.notificationModal.isDisposed()) {
      this.notificationModal = new NotificationModal(this.player, this.notificationOptions);
      this.player.addChild(this.notificationModal);
    }

    this.notificationModal.showMessage(message);
    if (this.notificationOptions.showTime) {
      this.player.setTimeout(() => {
        this.notificationModal && this.notificationModal.close();
      }, this.notificationOptions.showTime * 1000);
    }
  }

  dispose() {
    this.notificationModal && this.notificationModal.dispose();
    this.super();
  }
}

videojs.registerPlugin('notificationPlugin', NotificationPlugin);
